import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", {
      class: "relative flex md:gap-10 gap-4 bg-h-primary-500 bg-opacity-70 bg-cover items-center rounded-md my-6 py-6 px-9 bg-center lg:bg-cover w-full md:h-[138px] h-20",
      style: _normalizeStyle(`background-image: url(${_ctx.content.imageBanner}); `),
      id: "banner-forum"
    }, [
      _createElementVNode("div", {
        class: _normalizeClass([_ctx.isTeacherOrAdmin ? 'bg-gradient-to-r from-black/80 to-transparent' : '', "absolute inset-0 flex items-center gap-4 py-6 rounded-md px-9 md:gap-11"])
      }, [
        _createElementVNode("img", {
          src: require('@/assets/images/icon-forum.svg'),
          alt: "",
          class: "md:h-[96px] h-[40px]"
        }, null, 8, _hoisted_1),
        _createElementVNode("h2", {
          class: _normalizeClass(["text-white font-medium jost-span leading-10 text-[28px] md:text-5xl line-clamp-2", _ctx.isTeacherOrAdmin ? 'md:text-[28px]' : ''])
        }, _toDisplayString(_ctx.content.nameBanner), 3)
      ], 2)
    ], 4)
  ]))
}